import { TeacherModuleAttendanceView } from '@/views/TeacherModuleAttendanceView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const TeacherModuleAttendancePage = () => (
  <MainLayout meta={{ title: 'Attendance' }}>
    <TeacherModuleAttendanceView />
  </MainLayout>
);

export default TeacherModuleAttendancePage;
